import dynamic from 'next/dynamic';

const FormMultiSelect = dynamic(() => import('./FormMultiSelect'), { ssr: false });

export default FormMultiSelect;
